/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type DeleteItemModal_item$ref: FragmentReference;
declare export opaque type DeleteItemModal_item$fragmentType: DeleteItemModal_item$ref;
export type DeleteItemModal_item = {|
  +id: string,
  +name: string,
  +$refType: DeleteItemModal_item$ref,
|};
export type DeleteItemModal_item$data = DeleteItemModal_item;
export type DeleteItemModal_item$key = {
  +$data?: DeleteItemModal_item$data,
  +$fragmentRefs: DeleteItemModal_item$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "DeleteItemModal_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '7ceffb0f5d4e0f1fdf977b59b32b0983';
module.exports = node;
